import React, { useContext } from 'react';
import './Onboarding.scss';
import Onboardinghand from '../../../public/static/onbarding_hand_shh.svg';
import { KeyboardOptionKey } from '@mui/icons-material';
import { isMobile } from '../../../utils/app.helper';
import { AppContext } from '../../../state/app.state';

type Props={
    className?: string;
    id?: string;
    showOnboarding: boolean;
    showFinger: boolean;
    style?: object;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}
const Onboarding: React.FC<Props> = ({ children, className = '', id, onClick, showOnboarding, showFinger }) => {
    const { state } = useContext(AppContext);

    return (
        <>
            {showOnboarding &&
            <div
                className={`bv-onboarding ${className ? className : ''}`}
                id={id}
                data-testid='onboarding'
                onClick={onClick}
            >
                <div
                    className={'bv-onboarding-content'}
                    data-testid='bv-onboarding-content'>

                    <div>
                        {showFinger ? <div className='bv-onboarding-content-circle'>
                            <img src={'https://bovaljaren2.s3.eu-north-1.amazonaws.com/images/icons/onboarding_hand_shh.svg'} className='bv-onboarding-hand' alt='' />
                            <div className='bv-onboarding-content-text'>{state?.project?.onboardingText || 'Klicka i bilden för att hitta ditt nya boende'}</div>
                        </div> : <div className='bv-onboarding-content-text bv-onboarding-content-text--stand-alone'>{state?.project?.onboardingText || 'Klicka i bilden för att hitta ditt nya boende'}</div>}
                        {children}
                    </div>
                </div>
            </div>}
        </>
    );
};

export default Onboarding;